import { IconListNumbers } from '@xingternal/icons';
import {
  fixTripleClickSelection,
  isBlockActive,
  ORDERED_LIST_DEFINITIONS,
  toggleBlock,
} from '@xingternal/content-editor-plugin-helpers';

const buttonConfig = ({
  disabledForBlockTypes = [],
  icon = IconListNumbers,
  label = 'Ordered List',
  ...props
} = {}) => ({
  isDisabled: (editor) =>
    disabledForBlockTypes.some((element) => isBlockActive(editor, element)),
  isHighlighted: (editor) =>
    isBlockActive(editor, ORDERED_LIST_DEFINITIONS.type),
  icon,
  label,
  onClick: (event, editor) => {
    event.preventDefault();
    fixTripleClickSelection(editor);
    toggleBlock(editor, ORDERED_LIST_DEFINITIONS.type);
  },
  ...props,
});

export { buttonConfig };
